(() => {
  if (window.__T4S_FlashNavBtns) return;
  window.__T4S_FlashNavBtns = true;

  // ✅ 这些是 class（不是 id）
  const FLASH_CLASSES = [
    't4s-trending-design1',
    'id_recently_viewed',
    'id_product-recommendations',
    'id_popular-accessories',
  ];

  // ✅ 生成：.xxx .t4s-section-inner 的合集选择器
  const SECTION_SEL = FLASH_CLASSES
    .map(cls => `.${cls} .t4s-section-inner`)
    .join(',');

  const SLIDER_SEL = '.t4s-flicky-slider';

  function flashBtn(section, dir) {
    const btn = section.querySelector(
      dir === 'prev'
        ? '.flickityt4s-button.previous'
        : '.flickityt4s-button.next'
    );
    if (!btn) return;

    const cls = dir === 'prev' ? 'is-flash-prev' : 'is-flash-next';

    btn.classList.remove(cls);
    requestAnimationFrame(() => {
      btn.classList.add(cls);
      setTimeout(() => btn.classList.remove(cls), 180);
    });
  }

  // 1) 点击左右按钮（事件委托）
  document.addEventListener('click', (e) => {
    const section = e.target.closest(SECTION_SEL);
    if (!section) return;

    const btn = e.target.closest('.flickityt4s-button');
    if (!btn) return;

    requestAnimationFrame(() => {
      if (btn.classList.contains('previous')) flashBtn(section, 'prev');
      else if (btn.classList.contains('next')) flashBtn(section, 'next');
    });
  }, true);

  // 2) 拖拽滑动
  let startX = null;
  let activeSection = null;

  document.addEventListener('pointerdown', (e) => {
    const section = e.target.closest(SECTION_SEL);
    if (!section) return;

    const slider = e.target.closest(SLIDER_SEL);
    if (!slider) return;

    startX = e.clientX;
    activeSection = section;
  }, { passive: true });

  document.addEventListener('pointerup', (e) => {
    if (startX == null || !activeSection) return;

    const dx = e.clientX - startX;
    startX = null;

    if (Math.abs(dx) < 25) {
      activeSection = null;
      return;
    }

    flashBtn(activeSection, dx < 0 ? 'next' : 'prev');
    activeSection = null;
  }, { passive: true });
})();
